'use strict';

module.exports = require('child_process').spawnSync || require('./lib/spawn-sync');



//////////////////
// WEBPACK FOOTER
// ./~/spawn-sync/index.js
// module id = 1064
// module chunks = 0